var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTouchApp24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.714,
    height: 15,
    viewBox: "0 0 10.714 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.786,8.886V6.214a1.786,1.786,0,1,1,3.571,0V8.886a3.214,3.214,0,1,0-3.571,0Zm7.029,3.307-3.243-1.614a1.006,1.006,0,0,0-.386-.079h-.543V6.214a1.071,1.071,0,1,0-2.143,0v7.671l-2.45-.514a1.248,1.248,0,0,0-.171-.021.8.8,0,0,0-.564.236l-.564.571,3.529,3.529A1.075,1.075,0,0,0,9.036,18h4.85a1.04,1.04,0,0,0,1.029-.914l.536-3.764a1.027,1.027,0,0,0-.636-1.129Z",
    transform: "translate(-4.75 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTouchApp24Px);
export default __webpack_public_path__ + "static/media/ic_touch_app_24px.573e8670.svg";
export { ForwardRef as ReactComponent };